import { createSlice } from '@reduxjs/toolkit';

import locationApi from 'api/locationApi';
import { logout } from '../auth/index';

const initialState = {
  locations: [],
  selectedLocation: undefined,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocations: (state, action) => {
      state.locations = action.payload;
    },
    selectLocation: (state, action) => {
      state.selectedLocation = action.payload;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

export const { setLocations, selectLocation } = locationSlice.actions;

export const getLocations = (state) => state.location.locations;
export const getSelectedLocation = (state) => state.location.selectedLocation;

export const getLocationsAsync = () => async (dispatch) => {
  const locations = await locationApi.getAll();
  return dispatch(setLocations(locations));
};

export const getUserLocationsAsync = () => async (dispatch) => {
  const locations = await locationApi.getUserLocations();
  return dispatch(setLocations(locations));
};

export default locationSlice.reducer;
